
export default {
  init() {
    // JavaScript to be fired on pages that use the alternating section layout
    $(document).ready(function () {
      console.log('here')
      let border = $('#site-header-2 .primary-nav-2 ul.main-nav div.active-border'),
       navItem = $('#site-header-2 .primary-nav-2 ul.main-nav > li > a')

      navItem.on('mouseover', function() {
        activeBorder($(this))
        console.log($(this))
      })

      function activeBorder(item) {
        let leftPos = item.parent().position().left,
          topPos = item.parent().position().top,
          widthPos = item.parent().width(),
          heightPos = item.innerHeight()

        border.css({
          'left': leftPos,
          'width': widthPos,
          'top': topPos+heightPos,
        })
      }
      $(window).on('resize', function () {
        activeBorder($('#site-header-2 .primary-nav-2 ul.main-nav > li > a[aria-expanded=true]'))
      })
      activeBorder($('#site-header-2 .primary-nav-2 ul.main-nav > li > a[aria-expanded=true]'))
    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/navAnimation.js